import { createContext, useContext } from "react";

export type ViewBarSettings = {
  showGoals: boolean;
};

type ViewBarSettingsContext = ViewBarSettings & {
  setShowGoals: (showGoals: boolean) => void;
  removeByIdViewBarSettings: () => void;
};

export const ViewBarSettingsContext = createContext<ViewBarSettingsContext | undefined>(undefined);

export const useViewBarSettings = () => {
  const context = useContext(ViewBarSettingsContext);

  if (!context) throw new Error(`Expected ViewBarSettingsContext in ancestor tree.`);

  return context;
};

ViewBarSettingsContext.displayName = "ViewBarSettingsContext";
